import { render, staticRenderFns } from "./lab-select.vue?vue&type=template&id=965c506a&scoped=true"
import script from "./lab-select.vue?vue&type=script&lang=js"
export * from "./lab-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965c506a",
  null
  
)

export default component.exports